import styled from 'styled-components';
import media from '../../components/base/media';

export const ApartmentsWrapper = styled.div`
	padding: 2rem;
	padding-top: calc(${props => props.theme.header.headerHeightMobile} + 2rem);
	margin: 0 auto;
	margin-bottom: 10rem;

	${media.desktopSmall`
		padding-top: ${props => props.theme.header.headerHeightDesktop};
		padding-left: 4rem;
		padding-right: 4rem;
	`}

	${media.desktopLarge`
		padding-left: 6rem;
		padding-right: 6rem;
		margin-bottom: 20rem;
		max-width: calc(192rem + 12rem);
	`};
`;
